<div class="hot-toast-animated-icon" [style.color]="iconTheme?.primary">
  <ng-container *dynamicView="icon"></ng-container>
</div>
